'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.phone-sticky').length <= 0 ) {
        return
    }

    $('.phone-sticky').hover(function(){
        $('.phone-sticky__infos').show("slide", { direction: "left" }, 1000);
    }, function(){
        $('.phone-sticky__infos').show("slide", { direction: "right" }, 1000);
    })
}
